<template>
  <div class="mt-4">
    <form @submit.prevent="onSubmit" class="flex flex-col items-start">
      <label for="credits" class="text-sm font-medium text-gray-700 whitespace-nowrap">
        Credits
      </label>
      <div class="mt-1 w-full">
        <NumberInput v-model="credits" @input="formActions.clearFormErrors" required />
        <p class="text-red-500 text-sm mt-1">{{ errors.credits }}</p>
      </div>
      <label for="comment" class="text-sm font-medium text-gray-700 whitespace-nowrap mt-4">
        Comments
      </label>
      <div class="mt-1 w-full">
        <input id="comment" type="text" v-model="comment" class="form-field-no-icon sm:w-full outline-none"
          @input="formActions.clearFieldError('comment')" />
        <p class="text-red-500 text-sm mt-1">{{ errors.comment }}</p>
      </div>
      <button type="submit" :disabled="Object.keys(errors).length > 0" class="button-submit mt-5">
        Confirm
      </button>
    </form>
  </div>
</template>
<script>
import { ref } from "vue";
import NumberInput from "@/components/common/NumberInput";
import formMixin from "@/mixins/formMixin";
import eventBus from "@/utils/eventBus";
import useFormErrors from "@/api/formErrors";
import useConfirmationModal from "@/api/confirmationModal";

export default {
  name: "UserCreditsDeductAdmin",
  mixins: [formMixin],
  props: {
    userId: Number,
    default: null,
  },
  components: {
    NumberInput,
  },
  setup() {
    const { errors, formActions } = useFormErrors();
    const credits = ref(null);
    const comment = ref("")

    return {
      credits,
      comment,
      errors,
      formActions,
    };
  },
  methods: {
    async onSubmit() {
      const modal = useConfirmationModal();
      await modal.openModal({
        title: "Are you sure you want to confirm?",
        message: `This action will deduct ${this.credits} credits from the user`,
        onSubmit: () => this.handleDeductUserCreditsBalance(),
      });
    },
    async handleDeductUserCreditsBalance() {
      const response = await this.handleSubmissionErrors(
        () =>
          this.$alfredService.deductUserCreditsBalance({
            credits: this.credits,
            comment: this.comment,
            user_id: this.userId,
          }),
        { formActions: this.formActions, throwExceptions: false }
      );
      if (response) {
        eventBus.trigger("notify", {
          notification: {
            group: "top-right",
            type: "success",
            text: response["detail"],
          },
        });
      }
      if (this.userId) {
        await this.$store.dispatch("user/FETCH_USER", { userId: this.userId });
      }
    },
  },
};
</script>